export default function Hero() {
  return (
    <section className="relative min-h-screen flex flex-col justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="/images/hero/hero-bg.webp"
          alt="Lightbox Manufacturing"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-black/40"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-transparent to-black/50"></div>
      </div>

      {/* Red accent bar top */}
      <div className="absolute top-0 left-0 w-full h-1 bg-red-600"></div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8 w-full pt-20 md:pt-24 pb-12 md:pb-16">
        <div className="max-w-3xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-red-600/20 border border-red-500/40 text-red-400 text-xs font-semibold px-4 py-2 rounded-full mb-6 uppercase tracking-widest">
            <span className="w-2 h-2 bg-red-500 rounded-full inline-block"></span>
            İzmir'in Güvenilir Lightbox Üreticisi
          </div>

          <h1 className="text-5xl md:text-7xl font-black text-white leading-tight mb-3">
            İZMİR <span className="text-red-500">LIGHTBOX</span>
          </h1>
          <p className="text-xl md:text-2xl font-bold text-white/70 tracking-wide mb-6">
            İmalatı ve Işıklı Tabela Çözümleri
          </p>

          <p className="text-gray-300 text-lg md:text-xl leading-relaxed mb-4 max-w-xl">
            Reklamcılara Özel Fiyatlar ile İzmir ve Ege Bölgesinin Lider Lightbox Üreticisi
          </p>

          <p className="text-gray-400 text-base leading-relaxed mb-10 max-w-2xl">
            Tasarımdan baskıya, üretimden uygulamaya kadar tüm süreçleri profesyonel ekibimizle yönetiyoruz. 
            Özel ölçü ve tasarımlarla markanızı öne çıkarın.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="#products"
              className="bg-red-600 hover:bg-red-700 text-white font-bold px-8 py-4 rounded-md transition-all duration-300 text-center whitespace-nowrap cursor-pointer text-base"
            >
              Ürünleri İncele
            </a>
            <a
              href="#contact"
              className="border-2 border-white/60 hover:border-white text-white font-bold px-8 py-4 rounded-md transition-all duration-300 text-center whitespace-nowrap cursor-pointer text-base hover:bg-white/10"
            >
              Teklif Al
            </a>
          </div>
        </div>
      </div>

      {/* Bottom Features Bar */}
      <div className="relative z-10 w-full bg-red-600">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 divide-x divide-red-500">
            {[
              { icon: 'ri-pencil-ruler-2-line', title: 'Tasarım', desc: 'Uzman grafik tasarımcılarımızla markanıza özel tasarım' },
              { icon: 'ri-printer-line', title: 'Baskı', desc: 'Yüksek çözünürlüklü dijital baskı teknolojisi' },
              { icon: 'ri-tools-line', title: 'Üretim', desc: 'Modern tesislerimizde hızlı ve kaliteli üretim' },
              { icon: 'ri-map-pin-line', title: 'Uygulama', desc: 'Profesyonel montaj ve kurulum hizmeti' },
            ].map((item) => (
              <div key={item.title} className="flex items-start gap-3 px-4 md:px-8 py-5">
                <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-lg flex-shrink-0">
                  <i className={`${item.icon} text-white text-xl`}></i>
                </div>
                <div>
                  <div className="text-white font-bold text-sm">{item.title}</div>
                  <div className="text-white text-xs leading-relaxed hidden md:block">{item.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
